var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { urlAPI } from './api';
export var servicesApi = {
    signin: function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var rawResponse, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/signin"), {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(user),
                    })];
                case 1:
                    rawResponse = _a.sent();
                    console.log('servis status code', rawResponse.statusText);
                    return [4 /*yield*/, rawResponse.json()];
                case 2:
                    content = _a.sent();
                    return [2 /*return*/, content];
            }
        });
    }); },
    signup: function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var rawResponse, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/users"), {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(user),
                    })];
                case 1:
                    rawResponse = _a.sent();
                    return [4 /*yield*/, rawResponse.json().catch(function () { return false; })];
                case 2:
                    content = _a.sent();
                    return [2 /*return*/, content];
            }
        });
    }); },
};
export var servicesWordsApi = {
    getWords: function (group, page) {
        if (group === void 0) { group = '1'; }
        if (page === void 0) { page = 1; }
        return __awaiter(void 0, void 0, void 0, function () {
            var dataAllWords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/words?group=").concat(group, "&page=").concat(page - 1))
                            .then(function (res) { return res.json(); })
                            .then(function (data) {
                            // console.log(data);
                            return data;
                        })
                            .catch(function (error) {
                            console.log('Something went wrong', error.message);
                        })];
                    case 1:
                        dataAllWords = _a.sent();
                        return [2 /*return*/, dataAllWords];
                }
            });
        });
    },
    getWord: function (wordID) { return __awaiter(void 0, void 0, void 0, function () {
        var dataAllWords;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/words/").concat(wordID))
                        .then(function (res) { return res.json(); })
                        .then(function (data) {
                        // console.log(data);
                        return data;
                    })
                        .catch(function (error) {
                        console.log('Something went wrong', error.message);
                    })];
                case 1:
                    dataAllWords = _a.sent();
                    return [2 /*return*/, dataAllWords];
            }
        });
    }); },
    getUserWords: function (token, userId) { return __awaiter(void 0, void 0, void 0, function () {
        var rawResponse, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/users/").concat(userId, "/words"), {
                        method: 'GET',
                        // withCredentials: true,
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            Accept: 'application/json',
                        },
                    })];
                case 1:
                    rawResponse = _a.sent();
                    return [4 /*yield*/, rawResponse.json()];
                case 2:
                    content = _a.sent();
                    return [2 /*return*/, content];
            }
        });
    }); },
    createUserWord: function (token, userId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var word, rawResponse, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    word = {
                        difficulty: data.difficulty,
                        optional: data.optional,
                    };
                    return [4 /*yield*/, fetch("".concat(urlAPI, "/users/").concat(userId, "/words/").concat(data.wordId), {
                            method: 'POST',
                            // withCredentials: true,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(word),
                        })];
                case 1:
                    rawResponse = _a.sent();
                    return [4 /*yield*/, rawResponse.json()];
                case 2:
                    content = _a.sent();
                    return [2 /*return*/, content];
            }
        });
    }); },
    updateUserWord: function (token, userId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var word, rawResponse, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    word = {
                        difficulty: data.difficulty,
                        optional: data.optional,
                    };
                    return [4 /*yield*/, fetch("".concat(urlAPI, "/users/").concat(userId, "/words/").concat(data.wordId), {
                            method: 'PUT',
                            // withCredentials: true,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(word),
                        })];
                case 1:
                    rawResponse = _a.sent();
                    return [4 /*yield*/, rawResponse.json()];
                case 2:
                    content = _a.sent();
                    return [2 /*return*/, content];
            }
        });
    }); },
    getUserWord: function (token, _a) {
        var userId = _a.userId, wordId = _a.wordId;
        return __awaiter(void 0, void 0, void 0, function () {
            var content;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/users/").concat(userId, "/words/").concat(wordId), {
                            method: 'GET',
                            // withCredentials: true,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        }).then(function (data) { return data.json(); })];
                    case 1:
                        content = _b.sent();
                        return [2 /*return*/, content];
                }
            });
        });
    },
    deleteUserWord: function (token, _a) {
        var userId = _a.userId, wordId = _a.wordId;
        return __awaiter(void 0, void 0, void 0, function () {
            var content;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/users/").concat(userId, "/words/").concat(wordId), {
                            method: 'DELETE',
                            // withCredentials: true,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        })];
                    case 1:
                        content = _b.sent();
                        // const content = await rawResponse.json();
                        return [2 /*return*/, content];
                }
            });
        });
    },
};
export var loadImage = function (url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve(img); };
        img.src = url;
    });
};
export var audioPlayWord = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var audio, AudioContext, audioContext;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                AudioContext = window.AudioContext;
                audioContext = new AudioContext();
                return [4 /*yield*/, fetch(url)
                        .then(function (data) { return data.arrayBuffer(); })
                        .then(function (arrayBuffer) { return audioContext.decodeAudioData(arrayBuffer); })
                        .then(function (decodedAudio) {
                        audio = decodedAudio;
                    })
                        .then(function (data) {
                        var playSound = audioContext.createBufferSource();
                        playSound.buffer = audio;
                        playSound.connect(audioContext.destination);
                        playSound.start(audioContext.currentTime);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
